/**
 * Created by lency on 9/1/16.
 */
export default ($compile) => {
    'ngInject';
    return function (scope, elem) {
        const template = `<i class="ybicon" ng-class="{'yb-eye_open': show, 'yb-eye_close': !show}" ng-click="show = !show">`;
        let linkedScope = scope.$new(true);
        const linker = $compile(template);
        linkedScope.show = false;
        let ele = linker(linkedScope, function (a) {
            elem.before(a);
        })
        linkedScope.$watch('show', function (newV) {
            if (newV) {
                elem.attr('type', 'text')
            } else {
                elem.attr('type', 'password')
            }
        })
        function inputHandler () {
            if (linkedScope.show) {
                elem.val(elem.val().replace(/[\u4e00-\u9fa5]/g, ""))
            }
        }
        elem.on('input', inputHandler)
        linkedScope.$on('$destroy', function () {
            ele.remove();
            ele = null;
            elem.off('input', inputHandler)
        })
        scope.$on('$destroy', function () {
            linkedScope.$destroy();
            linkedScope = null;
        })
    };
};



// WEBPACK FOOTER //
// ./src/app/components/face/index/user/pwdMask.directive.js